import NavigationBar from './navigation-bar'

export default NavigationBar
